module.exports = __webpack_public_path__ + "img/orbit-logo.be570dcc.png";